import pino from "pino";

const logger = pino({
  level: process.env.NODE_ENV === "production" ? "warn" : "debug",
  browser: {
    asObject: false,
  },
});

export default logger;
